import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/signIn/storedSharingRisks.query.gql"
import type {
  StoredSharingRisksQuery,
  StoredSharingRisksQueryVariables,
} from "@/v2-backoffice-client/signIn/__types__/storedSharingRisks.query"

type Options = QueryHookOptions<
  StoredSharingRisksQuery,
  StoredSharingRisksQueryVariables
>

export function useStoredSharingRisksQuery(options?: Options) {
  return useQuery<StoredSharingRisksQuery, StoredSharingRisksQueryVariables>(
    query,
    options,
  )
}
